import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { IndicatorHeaderList } from './utils';

interface IndicatorHeaderStyleProps {
  selected?: boolean;
  index: number;
  total: number;
  isLastIndex: boolean;
  onClick?: () => unknown;
}

const StyledDiv = styled.div<IndicatorHeaderStyleProps>`
  ${({ isLastIndex, selected }) =>
    isLastIndex
      ? selected
        ? `border: 1px solid ${COLORS.ctaBrand}; border-radius: 6px; background-color: ${COLORS.whiteBase};`
        : `border: 1px solid ${COLORS.grayBase}; border-radius: 6px; background-color: ${COLORS.grayLightest};`
      : ''}
  ${({ index, total }) => `z-index: ${total - index}`}
  ${({ index }) => (index === 0 ? undefined : 'margin-left: -6px;')}
  position: relative;
  width: 190px;
  height: 56px;
  display: inline-block;
  ${({ onClick }) => (onClick ? 'cursor: pointer;' : '')}
  .background {
    fill: ${({ selected }) =>
      selected ? COLORS.whiteBase : COLORS.grayLightest};
    stroke: ${({ selected }) => (selected ? COLORS.ctaBrand : COLORS.greyBase)};
    position: absolute;
    left: 0;
    right: 0;
  }
  .indicator-header-content {
    height: 100%;
    display: flex;
    align-items: center;
    position: absolute;
    ${({ index }) => (index === 0 ? undefined : 'padding: 0px 0px 0px 20px;')}
    left: 0;
    right: 0;
    color: ${COLORS.blackBase};
    .icon {
      color: ${COLORS.ctaBrand};
      margin-left: 19px;
      margin-right: ${SPACERS.small};
    }
    .text {
      font-weight: 700;
      font-size: 12px;
      line-height: 12px;
      letter-space: -2%;
      text-align: left;
    }
  }
`;

interface IndicatorHeaderProps {
  selectedText?: IndicatorHeaderList;
  list: IndicatorHeaderList[];
  onClick?: (text: IndicatorHeaderList, index: number) => unknown;
}

const IndicatorHeader: React.FC<IndicatorHeaderProps> = ({
  list,
  selectedText,
  onClick,
}) => {
  return (
    <>
      {list.map((l, i) => {
        const selected = l.text === selectedText?.text;
        const isLastIndex = i === list.length - 1;
        return (
          <StyledDiv
            index={i}
            total={list.length}
            key={l.text}
            selected={selected}
            isLastIndex={isLastIndex}
            onClick={selected || !onClick ? undefined : () => onClick(l, i)}
          >
            {!isLastIndex && (
              <svg
                width="209"
                height="56"
                viewBox="0 0 209 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="background"
              >
                <path d={'M0.5 4C0.5 2.067 2.067 0.5 4 0.5H181.754C182.715 0.5 183.634 0.895211 184.295 1.59293L207.031 25.5929C208.31 ' +
                  '26.9429 208.31 29.0571 207.031 30.4071L184.295 54.4071C183.634 55.1048 182.715 55.5 181.754 55.5H4C2.067 55.5 ' +
                  '0.5 53.933 0.5 52V4Z'} />
              </svg>
            )}
            <div
              className={`indicator-header-content${
                isLastIndex ? '' : ' content-background'
              }`}
            >
              <FontAwesomeIcon size="2x" icon={l.icon} className="icon" />
              <TrueImpactText allowTextSelection={false} className="text">
                {l.text.toUpperCase()}
              </TrueImpactText>
            </div>
          </StyledDiv>
        );
      })}
    </>
  );
};

export default IndicatorHeader;
